import { render, staticRenderFns } from "./ChuteView.vue?vue&type=template&id=3807c251&scoped=true"
import script from "./ChuteView.vue?vue&type=script&lang=js"
export * from "./ChuteView.vue?vue&type=script&lang=js"
import style0 from "./ChuteView.vue?vue&type=style&index=0&id=3807c251&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807c251",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3807c251')) {
      api.createRecord('3807c251', component.options)
    } else {
      api.reload('3807c251', component.options)
    }
    module.hot.accept("./ChuteView.vue?vue&type=template&id=3807c251&scoped=true", function () {
      api.rerender('3807c251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/ChuteView.vue"
export default component.exports